import { QUERIES } from '@repo/ui/queries';

export const NAVBAR_QUERIES = {
  ...QUERIES,
  headerTabletMinWidth: `@media (min-width: 880px)`,
};
